module.exports = __webpack_public_path__ + "static/media/feedback-icon.748fbd6f.svg";